import { AccountTypeService } from '../services/account-type.service'
import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { Observable } from 'rxjs'

@Injectable()
export class MgaBlocked implements CanActivate {
  constructor(
    private router: Router,
    private accountTypeService: AccountTypeService
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.accountTypeService.isMga()) {
      // Redireciona para uma página permitida (ex: customers)
      this.router.navigate(['/customers'])
      return false
    }
    return true
  }
}

